import React, { useState, useEffect } from 'react';
import { Utilities, Enums} from "@utils";
import { IFollowupBy } from "@interfaces/screens/followupBy.interface";
import FollowupByPresenter from "@presenters/screens/followup-byProject.presenter";
import { MasterDataGrid } from "@/components/";
import { CustomRule } from 'devextreme-react/data-grid';
import styles from './index.module.scss';

export interface IOverlapProps {
    overData: any;
    beneficiariesDup: any;
    screen: string;
}

const Overlap: React.FC<any> = ({ overData, screen, beneficiariesDup }: IOverlapProps) => {
    const [auxData, setAuxData] = useState(null)
    const view: IFollowupBy = {
        state: {},
    };

	const presenter = new FollowupByPresenter(view);

    const getDuplicateCalculation = (column: any, pivot: any) => {
        return (
            (column.dataField === Enums.FollowupBasicFields.byBeneficiaries) ? 
                <CustomRule 
                    ignoreEmptyValue={true}
                    validationCallback={(e: any) => presenter.validateOverlapDetail(e, pivot, overData.overlap)}
                    message={presenter.followupLabels.get('errorOverlapByProject')}
                />
            :   ''
        )
    };

    const updateTotalTable = () => {
        let overlapSum = presenter.getOverlapSum(overData.overlap)
        let totalTable = presenter.getTableInstance(`beneficiaries-by-no-repeat`)?.getDataSource()?.items()
        let total = ((beneficiariesDup?.[2]?.value || 0) - overlapSum)

        if(totalTable?.length){
            totalTable[2].value = (total > 0) ? total : totalTable[2].value
            totalTable[0].auxTotal = (total > 0) ? total : totalTable[0].auxTotal
            totalTable[1].auxTotal = (total > 0) ? total : totalTable[1].auxTotal
            totalTable[2].auxTotal = (total > 0) ? total : totalTable[2].auxTotal
        }

        presenter.getTableInstance(`beneficiaries-by-no-repeat`).refresh()
    };

    const renderDetail = (item:any)=>{
        let auxCol = Utilities.copyObject(overData.columns)
        auxCol.forEach((col: any) => { 
            if(col.dataField === Enums.FollowupBasicFields.byBeneficiaries) col.allowEditing = true
        });

        return (
            <>
                <h6>{presenter.followupLabels.get('overlapFollowupBy')}</h6>
                <MasterDataGrid 
                    id={`overlaps-detail-${item.data.id}`}
                    dataSource={item.data.overlaps}
                    columns={auxCol}
                    allowCode={screen}
                    getDuplicateCalculation={(col) => getDuplicateCalculation(col, item.data)}
                    gridProps={{
                        onRowUpdated: () => updateTotalTable(),
                        editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
                        rowAlternationEnabled:false
                    }}            
                />
            </>
        )
    }

    useEffect(() => {
        if(overData?.overlap){
            setAuxData(
                <MasterDataGrid 
                    id={`overlaps-master`}
                    dataSource={overData.overlap}
                    columns={overData.columns}
                    allowCode={screen}
                    gridProps={{
                        width: '80%',
                        className: styles.overlap,
                        editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
                        rowAlternationEnabled:false,
                    }}
                    render = {renderDetail}                
                />
            )
        }
    }, [overData?.overlap, overData?.columns, screen]);

    return (        
        <>
            {auxData && auxData}
        </>
    )
}

export default Overlap;